/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { CmsLinkComponent } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CmsComponentData } from '../../../cms-structure/page/model/cms-component-data';

@Component({
  selector: 'cx-link',
  templateUrl: './link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  @HostBinding('class') styleClasses: string | undefined;

  data$: Observable<CmsLinkComponent> = this.component.data$.pipe(
    tap((data) => (this.styleClasses = data?.styleClasses)),
  );

  constructor(protected component: CmsComponentData<CmsLinkComponent>) {}

  /**
   * Returns `_blank` to force opening the link in a new window whenever the
   * `data.target` flag is set to `true`.
   */
  getTarget(data: CmsLinkComponent): string | null {
    return data.properties?.target === 'true' || data.properties?.target === true ? '_blank' : null;
  }
}
